var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
import { apiInternalInspectionConflictResolutionPath } from '@routes';
import { STRATEGY } from '../constants';
export const fetchSummary = (inspectionId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield api.get(apiInternalInspectionConflictResolutionPath(inspectionId));
    return response.data;
});
export const acceptByTechnician = (inspectionId, technicianId) => __awaiter(void 0, void 0, void 0, function* () {
    yield api.post(apiInternalInspectionConflictResolutionPath(inspectionId), { technician_id: technicianId });
});
export const keepMoreComplete = (inspectionId) => __awaiter(void 0, void 0, void 0, function* () {
    yield api.post(apiInternalInspectionConflictResolutionPath(inspectionId), { strategy: STRATEGY.KEEP_MOST_COMPLETE });
});
